import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import ServiceList from "./ServiceList";
import Notification from "../../../elements/notification/Notification";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import MaterialPagination from "../../../styles/materialPagination";
import ServiceFilter from "./ServiceFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const ServicesContainer = ({ match }) => {
  const [userServices, setUserServices] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const userId = match.params.id;

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "serviceName": checkFilterItem(history, "serviceName", null),
    "active": checkFilterItem(history, "active", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchServicesList = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/services/get-enable-by-user-services/" + userId + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setUserServices(response.data.services);
        setTotalPageCount(response.data["totalPageCount"])
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }

  useEffect(() => {
    fetchServicesList();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <ServiceFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <ServiceList
        userId={userId}
        fetchServicesList={fetchServicesList}
        userServices={userServices}
        notification={notification}
        setNotification={setNotification}
      />
      {totalPageCount > 1  &&
      <MaterialPagination
        count={totalPageCount}
        shape="rounded"
        page={filterData.page}
        onChange={(event, page) => onChangePage(event, page)}
      />}
    </>
  );
};

export default ServicesContainer;